import {
  DownloadRounded,
  FileOpenRounded,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { MapsCustom } from "./MapsCustom";

import Basarang from "../location/Basarang.json";
import Bataguh from "../location/Bataguh.json";
import Dahadup from "../location/Dahadup.json";
import KapuasBarat from "../location/Kapuas-Barat.json";
import KapuasHilir from "../location/Kapuas-Hilir.json";
import KapuasHulu from "../location/Kapuas-Hulu.json";
import KapuasKuala from "../location/Kapuas-Kuala.json";
import KapuasMurung from "../location/Kapuas-Murung.json";
import KapuasTengah from "../location/Kapuas-Tengah.json";
import KapuasTimur from "../location/Kapuas-Timur.json";
import MandauTalawang from "../location/Mandau-Talawang.json";
import Mantangai from "../location/Mantangai.json";
import PasakTalawang from "../location/Pasak-Talawang.json";
import PulauPetak from "../location/Pulau-Petak.json";
import Selat from "../location/Selat.json";
import TambanCatur from "../location/Tamban-Catur.json";
import Timpah from "../location/Timpah.json";
import Api from "../api/RestApi.json";

// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

export default function DetailDialog(params) {
  const dataJson = kapuasMaps.filter(
    (item) => item.title == params.data.kecamatan
  );
  console.log(params.file);
  const TitleContent = (props) => {
    const { title, content, alignTitle } = props;
    return (
      <Box>
        <Typography variant="h5" fontWeight={"bold"} align={alignTitle}>
          {title}
        </Typography>
        <Typography variant="caption" fontSize={20}>
          {content}
        </Typography>
      </Box>
    );
  };
  const TitleFile = (props) => {
    const { title, file, alignTitle, tipe } = props;
    return (
      <Box>
        <Typography
          variant="h5"
          fontWeight={"bold"}
          align={alignTitle}
          paddingBottom={2}
        >
          {title}
        </Typography>

        <Grid
          container
          direction={"column"}
          spacing={2}
          justifyContent={"center"}
          alignContent={"center"}
        >
          {file
            .filter((i) => i.tipe == tipe)
            .map((item, index) => (
              <Grid key={index}>
                <Box>
                  {tipe == "Image" ? (
                    <Button
                      href={Api.src + "/" + item.nama}
                      rel="noopener noreferrer"
                      target="_blank"
                    > 
                    <Box
                    padding={2}
                    // border={"1px solid grey"}
                    boxShadow={2}
                    borderRadius={2}
                    bgcolor={"white"}
                    >

                      <Box
                        component="img"
                        sx={{
                          maxHeight: { xs: 100, md: 200, lg: 250 },
                          maxWidth: { xs: 100, md: 200, lg: 250 },
                        }}
                        alt={item.nama}
                        src={Api.src + "/" + item.nama}
                      />
                    </Box>
                    </Button>
                  ) : (
                    <Box>
                      <Button
                        variant="contained"
                        href={Api.src + "/" + item.nama}
                        rel="noopener noreferrer"
                        target="_blank"
                        startIcon={<FileOpenRounded />}
                        endIcon={<DownloadRounded />}
                      >
                        {item.nama}
                      </Button>
                    </Box>
                  )}
                </Box>
              </Grid>
            ))}
        </Grid>
      </Box>
    );
  };

  return (
    <Box paddingX={4} py={{ xs: 10, md: 4 }} bgcolor={"#E1E1E1"}>
      <Grid container direction={"row"} spacing={4}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box bgcolor={"red"} height={"60vh"} width={"100%"} borderRadius={4}>
            <MapsCustom data={params.data} dataJson={dataJson} />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TitleContent title="Kabupaten" content="Kapuas" alignTitle="left" />
          <TitleContent
            title="Kecamatan"
            content={params.data.kecamatan}
            alignTitle="left"
          />
          <TitleContent
            title="Kelurahan"
            content={params.data.kelurahan}
            alignTitle="left"
          />
          <TitleContent
            title="Alamat"
            content={params.data.alamat}
            alignTitle="left"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 12 }}>
          <TitleContent
            title="Deskripsi"
            content={params.data.deskripsi}
            alignTitle="center"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            padding={4}
            bgcolor={"white"}
            border={"1px solid #D3D3D3"}
            borderRadius={4}
          >
            <TitleContent
              title="No. Telepon"
              content={params.data.telepon || "-"}
              alignTitle="left"
            />
            <TitleContent
              title="Email"
              content={params.data.email || "-"}
              alignTitle="left"
            />
            <TitleContent
              title="Website"
              content={params.data.website || "-"}
              alignTitle="left"
            />
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box
            padding={4}
            bgcolor={"white"}
            border={"1px solid #D3D3D3"}
            borderRadius={4}
          >
            <TitleContent
              title="Luas"
              content={numberFormat.format(params.data.luas) + " Ha"}
              alignTitle="left"
            />
            {params.data.produksi && (
              <TitleContent
                title="Produksi"
                content={numberFormat.format(params.data.produksi) + "/Tahun"}
                alignTitle="left"
              />
            )}
            {params.data.nilai && (
              <TitleContent
                title="Nilai"
                content={currencyFormatter.format(params.data.nilai)}
                alignTitle="left"
              />
            )}
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TitleFile
            title="File Dokumen"
            file={params.file}
            alignTitle="center"
            tipe="Document"
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TitleFile
            title="Galeri"
            file={params.file}
            alignTitle="center"
            tipe="Image"
          />
        </Grid>
      </Grid>
    </Box>
  );
}

const numberFormat = new Intl.NumberFormat();

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
});

const kapuasMaps = [
  {
    title: "Basarang",
    data: Basarang,
    center: [-2.960662909944844, 114.30593696968697],
    zoom: 11,
    color:"#FF0000"
  },
  {
    title: "Bataguh",
    data: Bataguh,
    center: [-3.1838413458253996, 114.27481185689663],
    zoom: 10,
    color:"#00FF00"
  },
  {
    title: "Dahadup",
    data: Dahadup,
    center: [-2.6286924437262087, 114.6281539106547],
    zoom: 10,
    color:"#0000FF"
  },
  {
    title: "Kapuas Barat",
    data: KapuasBarat,
    center: [-2.799383075019975, 114.38917206198403],
    zoom: 10,
    color:"#FFFF00"
  },
  {
    title: "Kapuas Hilir",
    data: KapuasHilir,
    center: [-2.9908446737791508, 114.45728719315639],
    zoom: 10,
    color:"#00FFFF"
  },
  {
    title: "Kapuas Hulu",
    data: KapuasHulu,
    center: [-0.7440771486200219, 113.77190680983551],
    zoom: 9,
    color:"#FF00FF"
  },
  {
    title: "Kapuas Kuala",
    data: KapuasKuala,
    center: [-3.337111635796532, 114.30279312308323],
    zoom: 10,
    color:"#FFA500"
  },
  {
    title: "Kapuas Murung",
    data: KapuasMurung,
    center: [-2.7508284730909622, 114.64556789592712],
    zoom: 10,
    color:"#800080 "
  },
  {
    title: "Kapuas Tengah",
    data: KapuasTengah,
    center: [-1.2019933801033176, 114.38017155535312],
    zoom: 10,
    color:"#FFC0CB"
  },
  {
    title: "Kapuas Timur",
    data: KapuasTimur,
    center: [-3.0683075423080624, 114.46009246298041],
    zoom: 10,
    color:"#A52A2A"
  },
  {
    title: "Mandau Talawang",
    data: MandauTalawang,
    center: [-0.6407911173025838, 113.97275881375054],
    zoom: 10,
    color:"#808080"
  },
  {
    title: "Mantangai",
    data: Mantangai,
    center: [-1.9955445831515561, 114.2984834881367],
    zoom: 8,
    color:"#991414ff"
  },
  {
    title: "Pasak Talawang",
    data: PasakTalawang,
    center: [-1.0333248378244377, 114.19078626115288],
    zoom: 10,
    color:"#000000"
  },
  {
    title: "Pulau Petak",
    data: PulauPetak,
    center: [-2.9025577320623057, 114.49425999424551],
    zoom: 10,
    color:"#FFFFFF"
  },
  {
    title: "Selat",
    data: Selat,
    center: [-2.9915998938563604, 114.39073715465673],
    zoom: 10,
    color:"#008080"
  },
  {
    title: "Tamban Catur",
    data: TambanCatur,
    center: [-3.2155543478857282, 114.38446817033315],
    zoom: 10,
    color:"#800000"
  },
  {
    title: "Timpah",
    data: Timpah,
    center: [-1.606636668699167, 114.51081176482086],
    zoom: 9,
    color:"#000080"
  },
];
